
import Navbar from "./navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import HRCAbout from './images/HRC_About.png';

function AboutUs() {
    const [isVisible, setIsVisible] = useState({});

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(prev => ({
                        ...prev,
                        [entry.target.id]: true
                    }));
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.fade-in-section').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    const values = [
        {
            title: "Excellence",
            description: "Delivering the highest quality products and services consistently",
            icon: "⭐"
        },
        {
            title: "Reliability",
            description: "Being a trustworthy partner you can depend on",
            icon: "🤝"
        },
        {
            title: "Innovation",
            description: "Constantly improving our solutions to meet evolving needs",
            icon: "💡"
        },
        {
            title: "Integrity",
            description: "Operating with honesty and transparency in all dealings",
            icon: "✅"
        }
    ];

    const achievements = [
        { number: "500+", label: "Partner Hotels" },
        { number: "1000+", label: "Products" },
        { number: "50+", label: "Cities" },
        { number: "10 yrs", label: "Industry Experience" }
    ];

    return (
        <>
            <style>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(180deg); }
                }
                @keyframes float-slow {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-30px) rotate(-180deg); }
                }
                @keyframes float-slower {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-40px); }
                }
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in-up {
                    animation: fadeInUp 1s ease-out;
                }
                .floating-shape {
                    position: absolute;
                    border-radius: 50%;
                    opacity: 0.1;
                    mix-blend-mode: multiply;
                }
                .shape-1 {
                    width: 300px;
                    height: 300px;
                    background: white;
                    top: 10%;
                    left: 10%;
                    animation: float 6s ease-in-out infinite;
                }
                .shape-2 {
                    width: 200px;
                    height: 200px;
                    background: white;
                    bottom: 20%;
                    right: 10%;
                    animation: float-slow 8s ease-in-out infinite;
                }
                .shape-3 {
                    width: 250px;
                    height: 250px;
                    background: white;
                    top: 50%;
                    right: 5%;
                    animation: float-slower 10s ease-in-out infinite;
                }
                @media (max-width: 640px) {
                    .floating-shape { display: none; }
                }
            `}</style>
            <ToastContainer />
            <div className="fixed top-0 w-full z-50">
                <Navbar />
            </div>

            {/* Hero Section */}
            <div className="relative pt-28 pb-16 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 text-white overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="floating-shape shape-1"></div>
                    <div className="floating-shape shape-2"></div>
                    <div className="floating-shape shape-3"></div>
                </div>
                
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
                    <div className="text-center space-y-6 animate-fade-in-up">
                        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold font-serif leading-tight">
                            About HRCPRO
                        </h1>
                        <p className="text-lg sm:text-xl lg:text-2xl font-serif font-light max-w-3xl mx-auto opacity-90">
                            Leading the hospitality industry with trusted solutions and unwavering commitment to excellence
                        </p>
                    </div>
                </div>
            </div>

            {/* Story Section */}
            <div className="py-16 sm:py-24 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div id="story" className="fade-in-section">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            <div className={`transition-all duration-1000 transform ${isVisible['story'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-serif text-blue-900 mb-6">
                                    Our Story
                                </h2>
                                <p className="text-lg sm:text-xl font-serif text-gray-700 mb-4 leading-relaxed">
                                    The journey of HRC Pro began with a simple observation: the hospitality world works hard to create beautiful experiences for guests, yet finding the right supplies behind the scenes was often anything but simple. Hotels struggled with unreliable vendors, cafés spent hours searching for quality products, and resorts wished someone understood their exact needs.
                                </p>
                                <p className="text-lg sm:text-xl font-serif text-gray-700 mb-4 leading-relaxed">
                                    We saw an opportunity — not just to sell products, but to bring ease, trust, and excitement back into the process.
                                </p>
                                <p className="text-lg sm:text-xl font-serif text-gray-700 leading-relaxed">
                                    That vision shaped HRC Pro into what it is today — a curated space where hospitality businesses can discover well-made, dependable, and thoughtfully designed essentials, all in one place. No confusion. No chasing multiple suppliers. No compromises on quality.
                                </p>
                            </div>
                            <div className={`transition-all duration-1000 transform ${isVisible['story'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                                <div className="relative h-96 bg-gradient-to-br from-blue-900 to-blue-700 rounded-3xl overflow-hidden shadow-2xl">
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        {/* <div className="text-6xl sm:text-7xl opacity-30">📊</div> */}
                                        <img src={HRCAbout} alt="About HRC Pro" className="w-full h-full object-cover"/>
                                    </div>
                                    <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-blue-300 opacity-50"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Achievements Section */}
            <div className="py-16 sm:py-24 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-serif text-blue-900 mb-4">
                            Our Achievements
                        </h2>
                        <p className="text-lg sm:text-xl font-serif text-gray-600">
                            Milestones that define our journey
                        </p>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
                        {achievements.map((item, index) => (
                            <div 
                                key={index}
                                id={`achievement-${index}`}
                                className="fade-in-section group"
                            >
                                <div className={`text-center p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 transform transition-all duration-1000 ${isVisible[`achievement-${index}`] ? 'opacity-100 scale-100' : 'opacity-0 scale-75'} hover:shadow-2xl hover:scale-105`}>
                                    <div className="text-4xl sm:text-5xl lg:text-6xl font-bold font-serif text-blue-900 mb-2 group-hover:text-blue-700 transition-colors">
                                        {item.number}
                                    </div>
                                    <p className="text-base sm:text-lg font-serif text-gray-700">
                                        {item.label}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Values Section */}
            <div className="py-16 sm:py-24 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-serif text-blue-900 mb-4">
                            Our Core Values
                        </h2>
                        <p className="text-lg sm:text-xl font-serif text-gray-600">
                            The principles that guide everything we do
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
                        {values?.map((value, index) => (
                            <div 
                                key={index}
                                id={`value-${index}`}
                                className="fade-in-section"
                            >
                                <div className={`h-full p-8 rounded-2xl bg-white shadow-lg hover:shadow-2xl transform transition-all duration-1000 ${isVisible[`value-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} hover:-translate-y-2`}>
                                    <div className="text-5xl mb-4 text-center">{value.icon}</div>
                                    <h3 className="text-xl sm:text-2xl font-bold font-serif text-blue-900 mb-3 text-center">
                                        {value.title}
                                    </h3>
                                    <p className="text-gray-700 text-center font-serif">
                                        {value.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Mission & Vision Section */}
            <div className="py-16 sm:py-24 bg-gradient-to-r from-blue-900 to-blue-950 text-white relative overflow-hidden">
                <div className="absolute inset-0 overflow-hidden opacity-10">
                    <div className="floating-shape shape-1"></div>
                    <div className="floating-shape shape-2"></div>
                </div>
                
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                        <div id="mission" className="fade-in-section">
                            <div className={`transition-all duration-1000 transform ${isVisible['mission'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                                <h3 className="text-3xl sm:text-4xl font-bold font-serif mb-6">
                                    Our Mission
                                </h3>
                                <p className="text-lg sm:text-xl font-serif leading-relaxed opacity-90">
                                    To be the most trusted and innovative procurement partner for the hospitality industry, delivering exceptional value through seamless sourcing, consistent quality, and personalized customer support.
                                </p>
                            </div>
                        </div>
                        <div id="vision" className="fade-in-section">
                            <div className={`transition-all duration-1000 transform ${isVisible['vision'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                                <h3 className="text-3xl sm:text-4xl font-bold font-serif mb-6">
                                    Our Vision
                                </h3>
                                <p className="text-lg sm:text-xl font-serif leading-relaxed opacity-90">
                                    To create a future where every hospitality establishment has access to world-class products and services, enabling them to focus on what they do best—delivering exceptional guest experiences.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="py-16 sm:py-24 bg-gray-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-serif text-blue-900 mb-6">
                        Ready to Partner With Us?
                    </h2>
                    <p className="text-lg sm:text-xl font-serif text-gray-700 mb-8">
                        Join hundreds of hospitality businesses that trust HRCPRO for their sourcing needs.
                    </p>
                    <a href="/contactus" className="inline-block bg-blue-900 hover:bg-blue-800 text-white font-bold text-lg sm:text-xl px-8 sm:px-10 py-3 sm:py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl font-serif">
                        Get in Touch
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div className="bg-white py-8 border-t border-gray-200">
                <div className="container mx-auto px-4">
                    <div className="text-black text-center">
                        <p className="text-lg font-serif">© 2025 HRCPRO. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutUs;